import React, { useEffect, useState, useRef } from "react";
import { Button, Card, CardBody, CardHeader, Container, Input, Label, Table, Form } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { Row, Col, FormGroup, FormFeedback } from 'reactstrap'
import { ToastContainer, toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import { Formik, ErrorMessage, FieldArray } from 'formik';
import { fetchCountries } from '../../slices/customer/countries/thunk';
import { commonIDFunction, isEmptyOrInvalidField, optionsForCustomerDetails } from '../Customers/constants/constantFunctions';
import { fetchCities } from '../../slices/customer/cities/thunk';
import { fetchStates } from '../../slices/customer/states/thunk';
import { useDispatch, useSelector } from "react-redux";
import { createPartners } from "../../slices/PartnerMangement/CreatePartner/thunk";
import { Loader } from '../../Components/Utils/Loader';
import { getAllPartnerListing } from "../../slices/PartnerMangement/ListingPartner/thunk";
import { customerIdData } from "../Customers/constants/constantFunctionsView";
import { editPartner } from "../../slices/PartnerMangement/EditPartner/thunk";
import { viewDoc } from "../../slices/customer/documentview/thunk";
import CommonButton from "../Utils/CommonButton";
import { validationSchema } from "./Constants/validationSchema";
import { jsonObj, editJsonObj } from "./Constants/PartnerUtils";
import BusinessProfileForm from "./BusinessProfile";
import PrimaryContactForm from "./PrimaryContact";
import { UserRoleOptions } from "./Constants/PartnerUtils";
import AttributeListForm from "./AttributeListForm";
import { PAGE_TITLES } from "../Common/constants";
import { handleRemoveLogo } from "./Constants/HandelRemoveLogo";

function CreatePartners() {
    const initialFormValues = {
        businessName: '',
        type: '',
        email: '',
        mobile: '',
        Address: '',
        country: '',
        city: '',
        state: '',
        websiteLink: '',
        zipCode: '',
        firstName: '',
        lastName: '',
        email1: '',
        mobile1: '',
        userName: '',
        userRole: '',
        addressLine2: '',
        attributeList: [],
        id: '',
        isSSOUser: false
    };

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const PartnerId = customerIdData()

    // State variables
    const [cities, setCities] = useState([])
    const [selectedCountry, setSelectedCountry] = useState('');
    const [selectedState, setSelectedState] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [loading, setLoading] = useState(false)
    const [logoFile, setLogoFile] = useState(null);
    const [editData, setEditData] = useState(null);
    const [imageOn, setImageOn] = useState(false);
    const [fileSelected, setFileSelected] = useState(false);
    const [profileData, setProfileData] = useState(false)
    const [callState, setCallState] = useState(false)
    const [callCity, setCallCity] = useState(false)
    const [dialCode, setDialCode] = useState("")
    const [dialCodeBP, setDialCodeBP] = useState("")
    const [onfocus, setOnFocus] = useState(false)
    const [onfocusBP, setOnFocusBP] = useState(false)

    // NEW: State to hold the actual initial values for Formik
    const [formInitialValues, setFormInitialValues] = useState(initialFormValues);
    const [dataLoaded, setDataLoaded] = useState(false);

    const fileInputRef = useRef(null);

    // Route detection
    const isEdit = location.pathname.includes('update-partner')
    const isCreate = location.pathname.includes('create-partner')

    // Redux selectors
    const countries = useSelector(state => state.Countries.countries)
    const PartnerlistData = useSelector(state => state.PartnerList.partnerList)
    const ViewDocument = useSelector(state => state.ViewDocument.documentView)
    const statesData = useSelector(state => state.States.states)
    const cityData = useSelector(state => state.Cities.cities)

    // Computed values
    let countryID = commonIDFunction(countries?.countries)
    const options = optionsForCustomerDetails(countryID)
    let stateID = commonIDFunction(statesData?.states)
    let optionState = optionsForCustomerDetails(stateID)
    let cityID = commonIDFunction(cityData?.cities)
    let optionCity = optionsForCustomerDetails(cityID)
    let base64ImageData = ViewDocument?.filePath
    let documentName = ViewDocument?.documentName
    let profile = useSelector((state) => state.ViewDocument.documentView)
    const [update, setUpdate] = useState(!!profile);

    // Load countries on component mount
    useEffect(() => {
        dispatch(fetchCountries(setLoading, setCallState))
    }, [dispatch]);

    // Load partner data for edit mode
    useEffect(() => {
        if (isEdit && PartnerId) {
            const loadEditData = async () => {
                try {
                    setLoading(true);
                    // Create a new object to hold the updated values
                    const updatedValues = { ...initialFormValues };

                    // Dispatch the action and wait for it to complete
                    await dispatch(getAllPartnerListing(
                        setLoading,
                        PartnerId,
                        updatedValues, // Pass the object to be populated
                        setEditData,
                        setDialCode,
                        setDialCodeBP
                    ));

                    // Set the form initial values with the populated data
                    setFormInitialValues(updatedValues);
                    setDataLoaded(true);
                } catch (error) {
                    console.error('Error loading edit data:', error);
                    setLoading(false);
                }
            };

            loadEditData();
        } else if (isCreate) {
            // For create mode, use default values
            setFormInitialValues(initialFormValues);
            setDataLoaded(true);
        }
    }, [dispatch, isEdit, PartnerId]);

    // Load logo for edit mode
    useEffect(() => {
        if (isEdit && editData && editData?.businessName) {
            const partnerOrCustomer = "Partner"
            dispatch(viewDoc(setLoading, PartnerId, "logo", partnerOrCustomer, setProfileData));
        }
    }, [dispatch, isEdit, editData, PartnerId]);

    // Set logo file when base64 data is available
    useEffect(() => {
        if (isEdit && base64ImageData) {
            setLogoFile(base64ImageData);
        }
    }, [isEdit, base64ImageData]);

    // Load states when country is selected
    useEffect(() => {
        if (callState && selectedCountry) {
            dispatch(fetchStates(selectedCountry, setCallCity))
        }
    }, [dispatch, selectedCountry, callState]);

    // Load cities when state is selected
    useEffect(() => {
        if (callCity && selectedCountry && selectedState) {
            dispatch(fetchCities(selectedCountry, selectedState))
        }
    }, [dispatch, selectedCountry, selectedState, callCity]);

    const submitPartner = (values) => {
        if (isEdit) {
            let editObj = editJsonObj(values, dialCode, dialCodeBP)
            dispatch(editPartner(editObj, setLoading, navigate, PartnerId, logoFile, profile, update, setUpdate, fileSelected, editData, setFileSelected))
        } else {
            let jsonObject = jsonObj(values, dialCode, dialCodeBP)
            dispatch(createPartners(jsonObject, setLoading, navigate, logoFile))
        }
    }

    // Don't render the form until data is loaded for edit mode
    if (isEdit && !dataLoaded) {
        return (
            <div id='csms' className='page-content'>
                <Container fluid>
                    <BreadCrumb title={PAGE_TITLES.EDIT_PARTNER} pageTitle={PAGE_TITLES.PARTNER_LIST} />
                    <Loader />
                </Container>
            </div>
        );
    }

    return (
        <React.Fragment>
            <Formik
                enableReinitialize={true} // Enable for both create and edit modes
                initialValues={formInitialValues} // Use the state-managed initial values
                validationSchema={validationSchema}
                onSubmit={async (values) => submitPartner(values)}
            >
                {({ handleSubmit, values, handleChange, errors, touched, handleBlur, setFieldValue, setFieldTouched, setTouched }) => (
                    <Form className="needs-validation" onSubmit={handleSubmit}>
                        <div id='csms' className='page-content'>
                            <Container fluid>
                                <BreadCrumb title={isEdit ? PAGE_TITLES.EDIT_PARTNER : PAGE_TITLES.ADD_PARTNER} pageTitle={PAGE_TITLES.PARTNER_LIST} />
                                <ToastContainer position='top-center' />
                                          <h5 className="rv-page-title p-0 ps-0 pb-3">{isEdit ? PAGE_TITLES.EDIT_PARTNER : PAGE_TITLES.ADD_PARTNER}</h5>

                                {loading && <Loader />}
                                <BusinessProfileForm
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    values={values}
                                    touched={touched}
                                    setFileSelected={setFileSelected}
                                    errors={errors}
                                    setFieldValue={setFieldValue}
                                    initialValues={formInitialValues} // Pass the current initial values
                                    options={options}
                                    setSelectedCountry={setSelectedCountry}
                                    setFieldTouched={setFieldTouched}
                                    setSelectedState={setSelectedState}
                                    setSelectedCity={setSelectedCity}
                                    setCities={setCities}
                                    optionState={optionState}
                                    optionCity={optionCity}
                                    fileInputRef={fileInputRef}
                                    setImageOn={setImageOn}
                                    setLogoFile={setLogoFile}
                                    isCreate={isCreate}
                                    handleRemoveLogo={handleRemoveLogo}
                                    logoFile={logoFile}
                                    profile={profile}
                                    imageOn={imageOn}
                                    dispatch={dispatch}
                                    setLoading={setLoading}
                                    setUpdate={setUpdate}
                                    documentName={documentName}
                                    PartnerId={PartnerId}
                                    isEdit={isEdit}
                                    setDialCode={setDialCodeBP}
                                    dialCode={dialCodeBP}
                                    setOnFocus={setOnFocusBP}
                                    onfocus={onfocusBP}
                                />
                                <PrimaryContactForm
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                    values={values}
                                    touched={touched}
                                    errors={errors}
                                    setFieldValue={setFieldValue}
                                    isEdit={isEdit}
                                    UserRoleOptions={UserRoleOptions}
                                    setDialCode={setDialCode}
                                    dialCode={dialCode}
                                    setOnFocus={setOnFocus}
                                    onfocus={onfocus}
                                />
                                <div className="p-2">
                                <AttributeListForm
                                    values={values}
                                    handleChange={handleChange}
                                    errors={errors}
                                    touched={touched}
                                    setTouched={setTouched}
                                    setFieldValue={setFieldValue}
                                /></div>
                                <Row lg={6} className=" justify-content-end mb-4 mt-3">
                                    <div className="live-preview">
                                        <div className="d-flex justify-content-end gap-2 ">
                                            <CommonButton
                                                outline={true}
                                                className={"btn-label rv-secondary-btn rounded-1 px-1 ps-3 py-1  w-md-auto text-nowrap"}
                                                color={"main-color"}
                                                type={"reset"}
                                                buttonAction={() => navigate('/partner-listing')}
                                                buttonText={"Cancel"}
                                                icon={<i className="ri-close-line label-icon align-middle fs-16 me-2" style={{ transform: "scaleX(-1)", borderLeft: "1px solid" }}></i>}
                                                btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
                                            />
                                            <CommonButton
                                                className={"btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"}
                                                color={"main-color"}
                                                type={'submit'}
                                                buttonText={"Save"}
                                                buttonAction={handleSubmit}
                                                icon={<i className="ri-save-line label-icon align-middle fs-16 me-2"></i>}
                                                btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
                                            />
                                        </div>
                                    </div>
                                </Row>
                            </Container>
                        </div>
                    </Form>
                )}
            </Formik>
        </React.Fragment>
    )
}

export default CreatePartners;